export default {"src":"/_next/static/media/manabg.c2aebfd8.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};